export default __webpack_public_path__ + "static/media/Accelerons_33.1ff77724.jpeg";